<template>
  <div class="content d-flex flex-column flex-column-fluid px-3">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Americana de Turismo",
    },
  },
  created() {
    this.$store.commit("layout/updateTitle", this.title);
    document.title = this.title;
  },
};
</script>

<style></style>
